import { Badge, Menu, Modal } from "@mantine/core";
import { BackTop, Table, Input, Space, Select, message, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { MembershipStatus, OTPConfirmation } from "../../components";
import { deletPatient, postAuthorizeFacility } from "../../helpers/api";
import { calcAge, hasPermission, setState } from "../../helpers/utilities";
import { EditPatientForm } from "../index";
import smalltalk from "smalltalk";
import MedicalHistory from "../../components/shared/medical-history";
import PatientJourney from "../../components/shared/patient-journey";
import MedicalReports from "../../components/shared/medical-reports";
import { action, getUser, resouces } from "../../helpers/auth";
import { IconDotsCircleHorizontal, IconInfoCircle } from "@tabler/icons";
import { PlanManagement } from "./components/plan";
import _ from "lodash";
import {
  MEMBERSHIP_BENEFIT_TYPE,
  MEMBERSHIP_STATUS,
} from "../../helpers/config";

const filters = {
  reset: "reset",
  unrestrictedMembers: "unrestrictedMembers",
  discountedMembers: "discountedMembers",
  segmentedMembers: "segmentedMembers",
  globalMembers: "globalMembers",
  localMembers: "localMembers",
  genderMale: "genderMale",
  genderFemale: "genderFemale",
};

const PatientsIndex = ({ patients, isFetching, onReload }) => {
  // const [ isNewObject, setIsNewObject ] = useState( false ); //newObject
  const [busy, setBusy] = useState(false);
  const [filter, setFilter] = useState(false);
  const [showingPaid, setShowingPaid] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [modal, setModal] = useState({
    title: "",
    open: false,
    content: "",
    size: 700,
  });

  // const { data: patients, isFetching, refetch: fetchPatients } = useQuery( {
  //   queryFn: getAllPatients,
  //   enabled: false,
  //   queryKey: [ 'patients' ],
  //   onSuccess: ( data ) => {
  //     setFilteredData( data );
  //   }
  // } );

  useEffect(() => {
    setFilteredData(patients);
  }, [patients]);

  const { Search } = Input;
  const { Option } = Select;

  const handleDeletePatient = (id) => {
    smalltalk
      .confirm(
        "Delete Member ",
        "This action cannot be undone. Delete Member?",
        {
          buttons: {
            ok: "YES",
            cancel: "NO",
          },
        }
      )
      .then((go) => {
        // delete patient api call
        deletPatient(id).then((res) => {
          if (res.status === 204) {
            message.success("Member deleted");
            onReload();
            return;
          }

          message.error(res.response.data.message);
        });
      })
      .catch((ex) => {
        // console.log(ex);
        message.error("error deleting member");
        return false;
      });
  };

  const confirmAuthorization = (patientId, otp) => {
    setBusy(true);

    postAuthorizeFacility(patientId, getUser().facility.id, "confirm", otp)
      .then((res) => {
        if (res.status === 201) {
          message.success("Confirmed!");
          setModal({ open: false });
          onReload();
          return;
        }

        message.error(res.message);
      })
      .catch((ex) => {
        // console.log( ex );
        message.error(ex.response.message);
      })
      .finally(() => {
        setBusy(false);
      });
  };

  const handleAccessRequest = (patientId) => {
    smalltalk
      .confirm(
        "Request Access",
        "This will ask member for authorization to their medical records. Continue?",
        {
          buttons: {
            ok: "YES",
            cancel: "NO",
          },
        }
      )
      .then((go) => {
        postAuthorizeFacility(
          patientId,
          getUser().facility.id,
          "authorize"
        ).then((res) => {
          if (res.status === 201)
            setModal({
              content: (
                <OTPConfirmation
                  isLoading={busy}
                  onSubmit={(otp) => confirmAuthorization(patientId, otp)}
                />
              ),
              open: true,
              title: "Authorize Facility",
            });

          message.error(res.response.data.message);
        });
      })
      .catch((ex) => {
        message.error(ex.response.data.message);
        return false;
      });
  };

  const handleSetFilter = (filterName) => {
    switch (filterName) {
      case filters.reset:
        setFilter(false);
        setFilteredData(patients);
        break;
      // case filters.cashlessMembers:
      //   setFilter(true);
      //   setFilteredData(
      //     patients.filter(
      //       (p) =>
      //         p.membershipSubscription?.benefitType !==
      //         MEMBERSHIP_BENEFIT_TYPE.DISCOUNTED
      //     )
      //   );
      //   break;
      case filters.discountedMembers:
        setFilter(true);
        setFilteredData(
          patients.filter(
            (p) =>
              p.membershipSubscription?.benefitType ===
              MEMBERSHIP_BENEFIT_TYPE.DISCOUNTED
          )
        );
        break;
      case filters.segmentedMembers:
        setFilter(true);
        setFilteredData(patients.filter((p) => p.membershipSubscription?.benefitType === MEMBERSHIP_BENEFIT_TYPE.SEGMENTED));
        break;
      case filters.unrestrictedMembers:
        setFilter(true);
        setFilteredData(
          patients.filter(
            (p) =>
              p.membershipSubscription?.benefitType ===
              MEMBERSHIP_BENEFIT_TYPE.UNRESTRICTED
          )
        );
        break;
      case filters.globalMembers:
        setFilter(true);
        setFilteredData(patients);
        break;
      case filters.localMembers:
        setFilter(true);
        setFilteredData(
          patients.filter((patient) =>
            patient.facilities.some(
              (facility) => facility.facilityId === getUser().facility.id
            )
          )
        );
        break;
      case filters.genderMale:
        setFilter(true);
        setFilteredData(patients.filter((d) => d.gender === "Male"));
        break;
      case filters.genderFemale:
        setFilter(true);
        setFilteredData(patients.filter((d) => d.gender === "Female"));
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    onReload();
  }, []);

  // sales table
  const columns = [
    {
      title: "Name",
      sorter: (a, b) => a?.firstName > b?.firstName,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) =>
        `${record?.firstName}  ${record?.lastName}`,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      sorter: (a, b) => a?.gender > b?.gender,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Age",
      sorter: (a, b) =>
        a?.dob && b?.dob
          ? new Date(a?.dob).getFullYear() > new Date(b?.dob).getFullYear()
          : 0,
      sortDirections: ["descend", "ascend"],
      render: (t, r, i) => (r?.dob ? calcAge(r?.dob).age : "-"),
    },
    {
      title: "Contact",
      dataIndex: "contact",
      sorter: (a, b) => a?.contact > b?.contact,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Occupation",
      dataIndex: "occupation",
      sorter: (a, b) => (a?.occupation || "") > (b?.occupation || ""),
      sortDirections: ["descend", "ascend"],
      render: (text) => text || "-",
    },
    {
      title: (
        <Tooltip title="Number of providers with edit access to each member's records">
          <span>
            <IconInfoCircle size={14} className="me-1" />
            Providers
          </span>
        </Tooltip>
      ),
      dataIndex: "facilities",
      width: 140,
      render: (facilities, record) =>
        Array.isArray(record?.facilities) ? record.facilities.length : 0,
      sorter: (a, b) =>
        (Array.isArray(a?.facilities) ? a.facilities.length : 0) -
        (Array.isArray(b?.facilities) ? b.facilities.length : 0),
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "Plan",
      dataIndex: ["membershipSubscription", "benefitType"],
      width: 150,
      sorter: (a, b) =>
        (a?.membershipSubscription?.benefitType || "") >
        (b?.membershipSubscription?.benefitType || ""),
      sortDirections: ["descend", "ascend"],
      render: (text, record) => {
        let benefitType = record?.membershipSubscription?.benefitType;
        if (!benefitType) return <Badge>-</Badge>;
        let color = "gray";

        if (benefitType === MEMBERSHIP_BENEFIT_TYPE.SEGMENTED) {
          benefitType = "Segmented";
          color = "blue";
        }
        else if (benefitType === MEMBERSHIP_BENEFIT_TYPE.UNRESTRICTED) {
          benefitType = "Cashless";
          color = "teal";
        }
        else if (benefitType === MEMBERSHIP_BENEFIT_TYPE.DISCOUNTED) {
          benefitType = "Regular";
          color = "orange";
        }


        return (
          <Badge color={color}>
            {benefitType}
          </Badge>
        );
      },
    },
    {
      title: "-",
      width: 40,
      render: (text, record, index) => {
        const membershipId = record?.membershipSubscription?.id;

        return (
          <Menu shadow="md" width={180}>
            <Menu.Target>
              {/* <button className="button is-small is-ghost px-2">
              <span className="bi bi-list me-2"></span>
            </button> */}
              <button className="button app-btn is-ghost">
                <IconDotsCircleHorizontal />
              </button>
            </Menu.Target>

            <Menu.Dropdown>
              {hasPermission(resouces.patients, action.canUpdate) && (
                <Menu.Item
                  icon={<span className="bi bi-eye" />}
                  color="blue"
                  onClick={() => {
                    setModal({
                      title:
                        "Editing " + record.firstName + " " + record.lastName,
                      open: true,
                      content: (
                        <EditPatientForm
                          patientId={record.id}
                          onSuccess={onReload}
                          showCharm={false}
                        />
                      ),
                      size: 600,
                    });
                  }}>
                  <span className="ms-1">Open</span>
                </Menu.Item>
              )}
              {hasPermission(resouces.patients, action.canRead) && (
                <>
                  <Menu.Item
                    icon={<span className="bi bi-signpost" />}
                    onClick={() =>
                      setModal({
                        title: "Journey",
                        open: true,
                        content: <PatientJourney patientId={record.id} />,
                        size: 1200,
                      })
                    }>
                    <span className="ms-1">Journey</span>
                  </Menu.Item>
                  <Menu.Item
                    icon={<span className="bi bi-journal-medical" />}
                    onClick={() =>
                      setModal({
                        title: "Medical History",
                        open: true,
                        content: (
                          <MedicalHistory
                            patientId={record.id}
                            isEditable={false}
                          />
                        ),
                      })
                    }>
                    <span className="ms-1">Medical History</span>
                  </Menu.Item>
                  <Menu.Item
                    icon={<span className="bi bi-file-earmark-medical" />}
                    onClick={() =>
                      setModal({
                        title: "Medical Reports",
                        open: true,
                        content: (
                          <MedicalReports
                            patientId={record.id}
                            patientName={
                              [record.firstName, record.lastName]
                                .filter(Boolean)
                                .join(" ")
                                .trim() || undefined
                            }
                            onUpdated={onReload}
                          />
                        ),
                        size: 1200,
                      })
                    }>
                    <span className="ms-1">Medical Reports</span>
                  </Menu.Item>
                </>
              )}
              {hasPermission(resouces.patients, action.canUpdate) && (
                <Menu.Item
                  icon={<span className="bi bi-unlock" />}
                  disabled={record?.facilities?.some(
                    (f) => f.facilityId === getUser().facility.id
                  )}
                  onClick={() => handleAccessRequest(record.id)}>
                  <span className="ms-1">Request Access</span>
                </Menu.Item>
              )}
              <Menu.Item
                icon={<span className="bi bi-heart" />}
                disabled={!membershipId}
                onClick={() =>
                  setModal({
                    title: "Membership Status",
                    open: true,
                    content: <MembershipStatus membershipId={membershipId} />,
                    size: 1200,
                  })
                }>
                <span className="ms-1">Membership</span>
              </Menu.Item>
              {/* <Menu.Item
              icon={<span className="bi bi-ui-checks-grid" />}
              onClick={() =>
                setModal({
                  title: "Plan Management",
                  open: true,
                  content: (
                    <PlanManagement
                      membershipId={
                        record?.membershipSubscription?.membershipId
                      }
                    />
                  ),
                  size: 900,
                })
              }
            >
              <span className="ms-1">Manage Plan</span>
            </Menu.Item> */}

              {hasPermission(resouces.patients, action.canDelete) && (
                <Menu.Item
                  icon={<span className="bi bi-trash" />}
                  color="red"
                  onClick={() => handleDeletePatient(record.id)}>
                  Delete
                </Menu.Item>
              )}
            </Menu.Dropdown>
          </Menu>
        );
      },
    },
  ];

  return (
    <section>
      <Modal
        title={modal.title}
        opened={modal.open}
        size={modal.size}
        onClose={() => setModal({ ...modal, open: false })}>
        {modal.content}
      </Modal>
      {/* <PageHeader
        title="Patients"
        hasBackButton
        description="List of all patients attended to"
      >
        {
          hasPermission( resouces.patients, action.canCreate ) &&
          <button
            class="app-btn btn-prim"
            onClick={ () => setIsNewObject( true ) }
          >
            <span className="bi bi-plus-circle me-2"></span>
            <strong className="text-white">NEW</strong>
          </button>
        }
      </PageHeader> */}
      {/* <Divider className="mt-1" /> */}

      {/* <FilterCard filter="filter" className="d-inline-block me-2" /> */}
      {/* <p>
        Showing <strong>{ filteredData.length }</strong>{ " " }
        { filteredData.length > 1 ? " records" : "record" }
      </p> */}
      <div className="my-3 d-flex justify-content-between">
        <Space className="ms-0">
          <input
            className="input"
            onChange={(e) =>
              setFilteredData(
                patients.filter(
                  (p) =>
                    p.firstName
                      .toLowerCase()
                      .includes(e.target.value.toLowerCase()) ||
                    p.lastName
                      .toLowerCase()
                      .includes(e.target.value.toLowerCase()) ||
                    p.gender
                      .toLowerCase()
                      .includes(e.target.value.toLowerCase()) ||
                    p.contact
                      .toLowerCase()
                      .includes(e.target.value.toLowerCase()) ||
                    p?.membershipSubscription?.plan?.planName
                      .toLowerCase()
                      .includes(e.target.value.toLowerCase())
                )
              )
            }
            title="start typing to filter"
            placeholder="start typing to filter"
            style={{ minWidth: "30vw" }}
          />
          {/* <Select
            style={{ minWidth: "100px" }}
            size="large"
            name="byType"
            allowClear
            showSearch
            onChange={(v) =>
              v != null
                ? setFilteredData(filteredData.filter((d) => d.gender === v))
                : setFilteredData(patients)
            }
            defaultValue="select gender"
          >
            {[...new Set(filteredData?.map((d) => d.gender))]?.map((v) => (
              <Option value={v} key={v}>
                {v}
              </Option>
            ))}
          </Select> */}
          {/* <button
            className="app-btn"
            onClick={() => {
              showingPaid
                ? setFilteredData(patients)
                : setFilteredData(
                    patients?.filter((pa) => pa.membershipSubscription)
                  );

              setShowingPaid(!showingPaid);
            }}
          >
            <span className="bi bi-cycle"></span>
            <span className="d-none d-md-inline">
              {showingPaid ? "Show All Members" : "Show Paid Members"}
            </span>
          </button> */}
        </Space>
        {/* <button
          onClick={ () => setState( setFilteredData, patients ) }
          className="app-btn btn-text ms-5 d-flex align-items-center"
        >
          <span className="bi bi-arrow-clockwise me-2"></span>
          Reset filters
        </button> */}

        <div className="d-flex">
          <button className="app-btn btn-text" onClick={onReload}>
            <span className="bi bi-cycle"></span>
            <span className="d-none d-md-inline">Refresh</span>
          </button>

          <Menu
            trigger="hover"
            withArrow
            transition="scale-y"
            shadow="md"
            position="bottom-right"
            width={220}
            className="d-block">
            <Menu.Target>
              <button
                className={`app-btn ${filter && " btn-prim"
                  } ms-2 d-flex align-items-center`}>
                <span
                  className={`bi ${filter ? "bi-funnel-fill" : "bi-funnel"
                    } me-2`}
                />
                <span className="d-none d-md-inline">
                  {filter ? `${filteredData?.length} Filtered` : "Filter"}
                </span>
              </button>
            </Menu.Target>

            <Menu.Dropdown ml={50}>
              <Menu.Item onClick={() => handleSetFilter(filters.reset)}>
                <span className="bi bi-arrow-clockwise me-2" />
                Reset Filters
              </Menu.Item>
              <Menu.Divider />
              <Menu.Label>Membership Type</Menu.Label>
              {/* <Menu.Item>All Members</Menu.Item> */}
              <Menu.Item
                onClick={() => handleSetFilter(filters.unrestrictedMembers)}>
                <span className="bi bi-cash me-2" />
                Cashless
              </Menu.Item>
              <Menu.Item
                onClick={() => handleSetFilter(filters.discountedMembers)}>
                <span className="bi bi-percent me-2" />
                Regular
              </Menu.Item>
              <Menu.Item
                onClick={() => handleSetFilter(filters.segmentedMembers)}>
                <span className="bi bi-person me-2" />
                Segmented
              </Menu.Item>
              <Menu.Divider />
              <Menu.Label>Member Scope</Menu.Label>
              <Menu.Item onClick={() => handleSetFilter(filters.globalMembers)}>
                <span className="bi bi-globe me-2" />
                Global
              </Menu.Item>
              <Menu.Item onClick={() => handleSetFilter(filters.localMembers)}>
                <span className="bi bi-geo me-2" />
                Local
              </Menu.Item>
              <Menu.Label>Gender</Menu.Label>
              <Menu.Item onClick={() => handleSetFilter(filters.genderMale)}>
                <span className="bi bi-gender-male me-2" />
                Male
              </Menu.Item>
              <Menu.Item onClick={() => handleSetFilter(filters.genderFemale)}>
                <span className="bi bi-gender-female me-2" />
                Female
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12">
          <Table
            className="border"
            rowKey={(record) => record.id}
            dataSource={filteredData}
            columns={columns}
            loading={isFetching}
            bordered
          />
        </div>
      </div>
      <BackTop />

      {/* { isNewObject && (
        <div className="row">
          <div className="col-md-8 col-12">
            <NewPatientForm
              onSuccess={ fetchPatients }
              onExit={ () => setIsNewObject( false ) }
            />
          </div>
        </div>
      ) } */}
    </section>
  );
};

export { PatientsIndex };
